<template>
  <div class="contract-table">
    <el-input
      v-model="keyword"
      placeholder="合同号"
      size="mini"
      clearable
      @input="filter"
      style="margin-bottom: 8px"
    />
<card-table
  ref="cardTableRef"
  :tableID="tableId"
  :tableData="filteredData"
  :tableColumn="columns"
  :showIndex="false"
  :mobileColumns="mobiletaskColumns"

  :showPaging="false"
  :height="'100%'"
  :loading="loading"
  :row-class-name="tableRowClassName"
  @rowClick="handleRowClick"
/>
  </div>
</template>

<script>
export default {
  name: 'contractTable',
  props: {
    contractData: Array,
    loading: Boolean,
    currentContractKey: String,
    tableId: { type: String, default: 'contractTable' }
  },
  data() {
    return {
      keyword: '',
      filteredData: [],
      columns: [{ prop: 'contractNo', label: '合同编号'}],
      mobiletaskColumns: [ 'contractNo' ],
      currentRow: null   // ✅ 当前选中行
    }
  },
  watch: {
    contractData: {
      immediate: true,
      handler(v) {
        this.filteredData = v
      }
    }
  },
  methods: {
    filter() {
      const k = this.keyword.trim().toLowerCase()
      this.filteredData = this.contractData.filter(i =>
        i.contractNo.toLowerCase().includes(k)
      )
    },

    // ✅ 点击行：锁定
    handleRowClick(row) {
      this.currentRow = row
      this.$emit('select', row)
    },

    // ✅ 给 el-table 用的 row-class-name
    tableRowClassName({ row }) {
      return this.currentRow === row ? 'selected-row' : ''
    }
  }
}
</script>

<style scoped>
.contract-table {
  display: flex;
  flex-direction: column;
  overflow: hidden; 
  height: 100%;
}
  .tab-bar {
    flex-shrink: 0;
    padding: 4px;
    border-bottom: 1px solid #ebeef5;
  }

  .table-box {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    position: relative;
  }

  /* ✅ 强制 card-table 滚动 */
  ::v-deep .card-table {
    height: 100%;
    overflow: auto;
  }

  /* 这句话起的作用让表格高度都一致 的 el-table */
  ::v-deep .el-table {
    height: 100% !important;
  }

  ::v-deep .el-table__body-wrapper {
    overflow-y: auto !important;
    overflow-x: auto !important;
  }


::v-deep .el-table .selected-row td {
  background-color: rgba(37, 100, 207, 0.2) !important;
  /* font-weight: bold; */
}

::v-deep .el-table__body tr.selected-row > td {
  background-color: rgba(37, 100, 207, 0.5) !important;
  font-weight: 500;
}

::v-deep .el-table .selected-row:hover td {
  background-color: rgba(37, 100, 207, 0.2) !important;
}



/* ✅ 强制覆盖 card-table */
.contract-table ::v-deep .card-table .el-table__header thead th {
  background-color: rgba(37, 100, 207, 0.2) !important;
}

.contract-table ::v-deep .card-table .el-table__body tbody td {
  background-color: rgba(37, 100, 207, 0.12) !important;
}

/* 滚动条区域 */
.contract-table ::v-deep .card-table .el-table__body-wrapper {
  background-color: rgba(37, 100, 207, 0.12);
}

/* ✅ 选中行：更深一点（最关键） */
.contract-table ::v-deep .el-table__body tr.selected-row > td {
  background-color: rgba(37, 100, 207, 0.3) !important;
  font-weight: 500;
}

</style>